module.exports = {
      id: "filter-usage",
      viewBox: "0 0 8 8",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#filter",
      toString: function () {
        return this.url;
      }
    }